import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { AddKategoriBody, AddKategoriResponse } from "../../constants/types";

const createKategori = async (body: AddKategoriBody) => {
    const response = await axios.post<AddKategoriResponse>(
        "/api/kategori",
        body,
    );
    return response.data;
};

export default function useCreateKategori() {
    const queryClient = useQueryClient();

    return useMutation((body: AddKategoriBody) => createKategori(body), {
        onSuccess: () => {
            queryClient.invalidateQueries(["kategori", "list"]);
        },
    });
}
